import { Component, OnInit,Input, Injectable } from '@angular/core';
import { MaintenanceService  } from '../../../service/lazarus/maintenance.service'
import { Column } from '../../../model/column'
import { Options } from '../../../model/options'
import Swal from 'sweetalert2';
import { ConditionClass } from '../../../model/condition'
import { SelectModal } from './selectmodal'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
declare var $: any;


@Component({
  selector: 'app-tablemaker',
  templateUrl: './tablemaker.component.html',
  styleUrls: ['./tablemaker.component.scss']
})
export class TablemakerComponent implements OnInit {

  constructor(
    private api:MaintenanceService,
    private modal:NgbModal
  ) { }

  protected loading: boolean = false;
  protected tableList:any = [] 
  protected columnList:Column[]= []
  protected columnListSelect:any= []
  protected tableName:string = '';
  protected dataTypes:any = [
    {
      value:'text',
      label:'Text'
    },
    {
      value:'number',
      label:'Number'
    },
    {
      value:'radio',
      label:'Radio'
    },
    {
      value:'select',
      label:'Select'
    },
    {
      value:'radio_table',
      label:'Radio Table'
    },
    {
      value:'select_table',
      label:'Select Table'
    },
    {
      value:'date',
      label:'Date'
    }
  ];

  protected yesNo: any =[
    {
       value:'1',
       label:'Yes'
    },
    {
      value:'0',
      label:'No'
    }
  ]

  conditions:ConditionClass[] = []

  ngOnInit() {
    //Get Table List
    this.getTableList()
  }

  saveTable(){
    this.loading = true
     this.api.saveTables(this.columnList).subscribe(
       (data) => {
        this.loading = false
        Swal.fire(
          'Record Saved',
          'Maintenance Table form for ' + this.tableName + ' has been saved',
          'success'
        )
        
       },
       (err) => {
        this.loading = false
            Swal.fire(
              'Record Saving Error',
              JSON.stringify(err),
              'error'
            )
       }
     )
  }

  addCondition(){
     const con:ConditionClass = new ConditionClass
     this.conditions.push(con)
  }

  getTableList(){
     this.api.getTables().subscribe(
       (data:any) => {
          this.tableList = data
       }
     )
  }

  getColumns(tblName){
    this.tableName = tblName
    this.loading = true
    this.api.getColumns(tblName).subscribe(
      (data:any) => {
        this.assignColumns(data)
        this.loading = false
      }
    )
  }

  getColumnsSelect(tblName){

    this.api.getColumns(tblName).subscribe(
      (data:any) => {
        this.columnListSelect = []
        console.log('Get Columns:' + data.is_new)
        console.log('Get Columns:' + data)
        for(let i =0; i < data.data.length; i++){
          const r = data.data[i]
          let colName = ''
          if(data.is_new){
             colName = r.COLUMN_NAME
          }else{
            colName  = r.column_name
          }
          
          this.columnListSelect.push(colName)
        }
      }
    )
  }

  updateOptions(col_type){
    if(col_type=='select_table' || col_type=='radio_table'){
      return {
        'table_name':'',
        'column_value':'',
        'column_label':''
      }
    }
    return []
  }

  assignColumns(data){
    //console.log('Assigned:' + data)
    //console.log('Assigned:' + data.length)
    this.columnList =[]
    for(let i =0; i < data.data.length; i++){
      const r = data.data[i]
      let nRow:Column = new Column
      if(data.is_new == true){
        nRow.table_name = this.tableName
        nRow.table_type = 'table'
        nRow.column_name = r.COLUMN_NAME
        nRow.column_type = this.checkDataType(r.DATA_TYPE)
        nRow.label = this.fixLabel(nRow.column_name)
        
        if(r.IS_NULLABLE == 'YES'){
          nRow.is_required = '0'
        }else{
          nRow.is_required = '1'
        }
        nRow.grid_size = '4'
        nRow.options = []
      }else{
         //Old record
         nRow = r
         if(nRow.column_type=='select' || nRow.column_type=='radio'){
           nRow.options = JSON.parse(nRow.options)
         }
      }
      
      console.log(nRow)
      this.columnList.push(nRow)
    }
  }

  addOptions(optList){
    let opt:Options = new Options
    optList.push(opt)
    return optList
  }

  removeOptions(rIndex,index){
    console.log('Option remove:' + index)
    return this.columnList[rIndex].options.splice(index,1)
  }

  /**  Helper Functions */ 

  fixLabel(str:string){
    let sp = str.split("_")
    let newString = ''
    for(let i =0; i < sp.length; i++){
      let r = sp[i]
      r =  r.charAt(0).toUpperCase() +  r.substring(1)
      if(i==0){
        newString = newString +  r
      }else{
        newString = newString + ' ' +  r
      }
    }

    return newString
  }

  checkDataType(type){
     if(type =='varchar' || type =='text' || type =='longtext'){
       return 'text'
     }else if(type =='int' || type =='bigint' || type =='double'){
      return 'number'
     }else if(type =='date' || type =='datetime' ){
      return 'date'
     }else{
       return 'text'
     }
  }
  showModal():void {
    console.log('Show modal triggered')
    $("#myModal").modal('show');
    console.log('Show modal end')
  }

  //Select
  loadSelectModal(){
    const modRef = this.modal.open(SelectModal,{size:'lg'});
    modRef.componentInstance.column_id = this.tableList;

    // modRef.componentInstance.selectValue.subscribe(
    //   (data) => {
    //     alert('Data from modal:' + data)
    //   }
    // )
    
    modRef.componentInstance.selectValue.subscribe(
      (data) => {
        alert('Data from modal:' + data)
      }
    )
  }
  
}


